import React from "react";
import { Form } from "react-bootstrap";

const TextArea = ({
  name,
  value,
  onChange,
  onBlur,
  label,
  error,
  required = false,
  textareaClassName = "bg-light",
  disabled = false,
  hint = "",
  placeholder = null,
}) => {
  const defaultValue = typeof value === "number" ? 0 : "";

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && "*"}
      </Form.Label>
      <Form.Control
        name={name}
        className={textareaClassName}
        as="textarea"
        disabled={disabled}
        placeholder={placeholder}
        onBlur={onBlur}
        onChange={onChange}
        value={value ?? defaultValue}
      />
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      {error && <small className="text-danger">{error}</small>}
    </Form.Group>
  );
};

export default TextArea;
